export default __webpack_public_path__ + "static/media/outlook-logo.5ae86490.png";